import PantallaPortadaContainer from './containers/pantalla-portada-container'
export default PantallaPortadaContainer
